import { render, staticRenderFns } from "./FestivalBonusInfo.vue?vue&type=template&id=3e054467&scoped=true&"
import script from "./FestivalBonusInfo.vue?vue&type=script&lang=js&"
export * from "./FestivalBonusInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e054467",
  null
  
)

export default component.exports